import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getCommunityFeed,
  addFeedPosts,
  ADD_PAGE,
  SAVE_PAGE,
  TOGGLE_HAS_MORE,
  filterFeed,
  TOGGLE_NO_MORE_FEED,
  GET_FEEDS_SUCCESS,
} from "../../redux/actions/userReflection";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

import Sidebar from "../../components/Sidebar/Sidebar";
import ButtonBlue from "../../components/Button/ButtonBlue";
import Button from "../../components/Button/Button";
import ReflectionCards from "../../components/reflectionCards";

import "../../styles/feed.styles.scss";

import * as AiIcons from "react-icons/ai";
import SearchBar from "../../components/Searchbar";
import axios from "axios";
import { serverUrl } from "../../components/Helpers/Config";
import { staticFiles } from "../../components/Helpers/Static";
import { showSharepost } from "../../redux/actions/sharePost";
import { ViewList, ViewModule } from "@material-ui/icons";
import {
  getUserPreference,
  putUserPreference,
} from "../../redux/actions/commonAction";
import {
  ButtonCommonTopNew,
  ButtonGrid,
  ButtonGridActive,
  ButtonGridNew,
  ButtonGridActiveNew,
} from "../Theme";
import ButtonCommon from "../../components/Button/ButtonCommon";
import { HiShare } from "react-icons/hi";
import {
  CommunityLoader,
  CommunityLoadMoreLoader,
} from "../../components/Button/Loader";
function Feed(props) {
  const SIDEBARDATA = [
    {
      title: "Topics",
      iconClosed: <AiIcons.AiFillCaretRight />,
      iconOpened: <AiIcons.AiFillCaretDown />,
      item: [],
      open: true,
    },
    {
      title: "Values/Competencies",
      iconClosed: <AiIcons.AiFillCaretRight />,
      iconOpened: <AiIcons.AiFillCaretDown />,
      item: [],
      open: false,
    },
  ];

  const dispatch = useDispatch();

  const page = useSelector((state) => state.reflections.page);
  const pagePreference = useSelector(
    (state) => state.commonData.pagePreference
  );

  const reflections = useSelector((state) => state.reflections.reflections);
  const groups = useSelector((state) => state.reflections.groups);
  const loading = useSelector((state) => state.reflections.loading);
  const [hasMore, setHasMore] = useState(true);
  const spage = useSelector((state) => state.reflections.spage);
  const userProfile = useSelector((state) => state.auth.user);

  const [filterOptions, setFilterOptions] = useState(SIDEBARDATA);
  const [groupedFilterData, setgroupedFilterData] = useState([]);
  const [grouepdValuedata, setGroupedValueData] = useState([]);
  const [selectedOption, setSelectedOption] = useState({
    type: -1,
    value: "",
  });
  const [filter, setFilter] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("");
  const [searchField, setSearchField] = useState("");
  const [filteredPost, setFilteredPost] = useState([]);

  const [isStudent, setisStudent] = useState(false);
  const [isTutor, setisTutor] = useState(false);
  const [isGrid, setisGrid] = useState(true);
  const [isMobile, setisMobile] = useState(false);
  const isChange = useSelector((state) => state.reflections.change);
  const limit = 10;
  const currentFeedFilter = useSelector(
    (state) => state.reflections.currentFeedFilter
  );
  useEffect(() => {
    if (userProfile.role === "MANAGER") {
      setisTutor(true);
      setisStudent(false);
    }
    if (userProfile.role === "MEMBER") {
      setisTutor(false);
      setisStudent(true);
    }
  }, [userProfile]);

  // useEffect(() => {
  //   if (isTutor || isStudent) {
  //     const fetchData = async () => {
  //       try {
  //         const feedRequest = axios.get(
  //           serverUrl.CommunityFeed +
  //             `?is_tutor=${isTutor}&is_student=${isStudent}`
  //         );
  //         const communityRequest = axios.get(
  //           serverUrl.Community +
  //             `?offset=0&is_tutor=${isTutor}&is_student=${isStudent}`
  //         );

  //         // 2️⃣ Wait for both to resolve
  //         const [resp1, resp2] = await Promise.all([
  //           feedRequest,
  //           communityRequest,
  //         ]);
  //         debugger;

  //         // 3️⃣ Process first response fully
  //         if (resp1.status === 200) {
  //           let currentFilterOptions = [...filterOptions];

  //           const grouped = Object.values(
  //             resp1?.data?.topics.reduce((acc, curr) => {
  //               const profileId = curr.profile_id || "Others";
  //               if (!acc[profileId]) {
  //                 acc[profileId] = {
  //                   title: curr.profile_name || "Others",
  //                   iconClosed: <AiIcons.AiFillCaretRight />,
  //                   iconOpened: <AiIcons.AiFillCaretDown />,
  //                   item: [],
  //                   open: false,
  //                 };
  //               }
  //               acc[profileId].item.push({
  //                 id: curr.event_id,
  //                 value: curr.event_title,
  //                 count: curr.tagged_count,
  //               });
  //               return acc;
  //             }, {})
  //           )
  //             .filter((group) => group.title !== "Others")
  //             .sort((a, b) => String(a.title).localeCompare(String(b.title)));

  //           setgroupedFilterData(grouped);

  //           currentFilterOptions[0].item = resp1?.data?.topics.map((item) => ({
  //             id: item.event_id,
  //             value: item.event_title,
  //             count: item.tagged_count,
  //           }));

  //           const groupedByVisCat = Object.values(
  //             resp1?.data?.values?.reduce((acc, curr) => {
  //               const visKey = curr.category_visualization || "Others";
  //               const catKey = curr.category_title || "Untitled";
  //               const groupKey =
  //                 visKey === "Others" ? "Others" : `${visKey}: ${catKey}`;

  //               if (!acc[groupKey]) {
  //                 acc[groupKey] = {
  //                   title: groupKey,
  //                   iconClosed: <AiIcons.AiFillCaretRight />,
  //                   iconOpened: <AiIcons.AiFillCaretDown />,
  //                   open: false,
  //                   item: [],
  //                 };
  //               }
  //               acc[groupKey].item.push({
  //                 id: curr.value_id,
  //                 value: curr.value_title,
  //                 count: curr.tagged_count,
  //               });
  //               return acc;
  //             }, {}) || {}
  //           )
  //             .filter((group) => group.title !== "Others")
  //             .sort((a, b) => String(a.title).localeCompare(String(b.title)));

  //           setGroupedValueData(groupedByVisCat);

  //           currentFilterOptions[1].item = resp1?.data?.values.map((item) => ({
  //             id: item.value_id,
  //             value: item.value_title,
  //             count: item.tagged_count,
  //           }));

  //           setFilterOptions(currentFilterOptions);
  //         }

  //         // 4️⃣ Now process second response
  //         if (resp2.status === 200) {
  //           const feeds = resp2.data.posts;
  //           const groups = resp2.data.groups;
  //           dispatch({
  //             type: feeds.length < 5 ? TOGGLE_NO_MORE_FEED : GET_FEEDS_SUCCESS,
  //             payload: { feeds, groups },
  //           });
  //         }
  //       } catch (error) {
  //         console.error("Error fetching data:", error);
  //       }
  //     };

  //     fetchData();
  //     return () => {
  //       dispatch({ type: SAVE_PAGE });
  //     };
  //   }
  // }, [isTutor, isStudent, isChange]);

  useEffect(() => {
    if (isTutor || isStudent) {
      dispatch(getCommunityFeed(0, isTutor, isStudent, limit));
      axios
        .get(
          serverUrl.CommunityFeed +
            `?is_tutor=${isTutor}&is_student=${isStudent}`
        )
        .then((resp) => {
          if (resp.status === 200) {
            let currentFilterOptions = [...filterOptions];
            const grouped = Object.values(
              resp?.data?.topics.reduce((acc, curr) => {
                const profileId = curr.profile_id || "Others"; // handle null profile_id
                if (!acc[profileId]) {
                  acc[profileId] = {
                    title: curr.profile_name || "Others",
                    iconClosed: <AiIcons.AiFillCaretRight />,
                    iconOpened: <AiIcons.AiFillCaretDown />,
                    item: [],
                    open: false,
                  };
                }

                // push event into that profile group
                acc[profileId].item.push({
                  id: curr.event_id,
                  value: curr.event_title,
                  count: curr.tagged_count,
                });

                return acc;
              }, {})
            )
              .filter((group) => group.title !== "Others")
              .sort((a, b) => String(a.title).localeCompare(String(b.title)));
            if (grouped?.length > 0) {
              grouped[0].open = true;
            }
            setgroupedFilterData(grouped);
            currentFilterOptions[0].item = resp?.data?.topics?.map((item) => ({
              id: item.event_id,
              value: item.event_title,
              count: item.tagged_count,
            }));
            const groupedByVisCat = Object.values(
              resp?.data?.values?.reduce((acc, curr) => {
                const visKey = curr.category_visualization || "Others";
                const catKey = curr.category_title || "Untitled";

                // title format "v3sk: Community"
                const groupKey =
                  visKey == "Others" ? "Others" : `${visKey}: ${catKey}`;

                if (!acc[groupKey]) {
                  acc[groupKey] = {
                    title: groupKey,
                    iconClosed: <AiIcons.AiFillCaretRight />,
                    iconOpened: <AiIcons.AiFillCaretDown />,
                    open: false,
                    item: [],
                  };
                }

                acc[groupKey].item.push({
                  id: curr.value_id,
                  value: curr.value_title,
                  count: curr.tagged_count,
                });

                return acc;
              }, {}) || {}
            )
              .filter((group) => group.title !== "Others")
              .sort((a, b) => String(a.title).localeCompare(String(b.title)));
            if (grouped?.length == 0 && groupedByVisCat?.length > 0) {
              groupedByVisCat[0].open = true;
            }
            setGroupedValueData(groupedByVisCat);
            currentFilterOptions[1].item = resp?.data?.values.map((item) => ({
              id: item.value_id,
              value: item.value_title,
              count: item.tagged_count,
            }));
            setFilterOptions(currentFilterOptions);
          }
        });
      return () => {
        dispatch({ type: SAVE_PAGE });
      };
    }
  }, [isTutor, isStudent, isChange]);

  const loadMorePost = () => {
    const offset = reflections ? reflections.length : 0;
    axios
      .get(
        serverUrl.Community +
          `?offset=${offset}&is_tutor=${isTutor}&limit=${limit}&is_student=${isStudent}`
      )
      .then((resp) => {
        if (resp.status === 200) {
          const feedPosts = resp.data.posts;
          if (feedPosts.length > 0) {
            dispatch(addFeedPosts(feedPosts));
          } else {
            setHasMore(false);
          }
        }
      });
  };

  useEffect(() => {
    // Dropdown
    let [eventId, valueId] = [0, 0];
    if (selectedOption.type === 0) {
      eventId = selectedOption.value;
    } else if (selectedOption.type === 1) {
      valueId = parseInt(selectedOption.value);
    }

    if (eventId === 0 && valueId === 0) {
      setFilteredPost(reflections);
    } else {
      setSearchField("");
      filterFeed(eventId, valueId);
    }
  }, [selectedOption, reflections]);

  const setFilterValue = (type, value) => {
    setSelectedOption({ type, value });
  };

  useEffect(() => {
    if (currentFeedFilter) {
      setSelectedOption(currentFeedFilter);
    }
    dispatch({
      type: "feedFilter",
      payload: null,
    });
  }, []);

  const filterFeed = (eventId, valueId) => {
    axios
      .post(serverUrl.Community + `/filter`, {
        event_id: eventId,
        value_id: valueId,
      })
      .then((resp) => {
        if (resp.status === 200) {
          let filtered = resp.data.posts;
          setFilteredPost(filtered);
          setHasMore(false);
        }
      });
  };

  const searchFeed = (val) => {
    if (val.length != 0) {
      axios.get(serverUrl.Community + `/search/${val}`).then((resp) => {
        if (resp.status === 200) {
          let searched = resp.data.posts;
          setFilteredPost(searched);
          setHasMore(false);
        }
      });
    } else {
      setFilteredPost(reflections);
    }
  };

  const handleSearch = (val) => {
    setSearchField(val);
    searchFeed(val);
  };

  useEffect(() => {
    dispatch(getUserPreference());
    const interval = setInterval(() => {
      resize();
    }, 100);
    return () => {
      clearInterval(interval);
    };
  }, []);

  const resize = () => {
    if (window.innerWidth < 768) {
      setisMobile(true);
      setisGrid(false);
    } else {
      setisMobile(false);
      let data = localStorage.getItem("is_grid") == "true" ? true : false;
      setisGrid(data);
    }
  };

  useEffect(() => {
    let data = pagePreference["feed_is_grid"];
    setisGrid(data);
    localStorage.setItem("is_grid", data);
  }, [pagePreference]);

  const updatePreference = (data) => {
    if (isGrid != data) {
      pagePreference["feed_is_grid"] = !isGrid;
      localStorage.setItem("is_grid", !isGrid);
      setisGrid(!isGrid);
      dispatch(putUserPreference(pagePreference));
    }
  };

  const saveFilter = () => {
    dispatch({
      type: "feedFilter",
      payload: selectedOption,
    });
  };

  return (
    <>
      {loading ? (
        <CommunityLoader />
      ) : (
        <div className="flex flex-col md:flex-col lg:flex-row pt-0 mb-8">
          <div className="flex flex-row-reverse lg:flex-col border-right-f1">
            <div className="w-full border-bottom-f1 p-4 box-border">
              <SearchBar setSearchField={handleSearch} onClick={searchFeed} />
            </div>
            <Sidebar
              data={filterOptions}
              selectedOption={selectedOption}
              setSelectedOption={setFilterValue}
              isFeed={true}
              groupedFilterData={groupedFilterData}
              grouepdValuedata={grouepdValuedata}
            />
          </div>
          {/* <Sidebar active={show} data={SIDEBARDATA} set={setShow} /> */}

          <div className="w-full backGroundColor pb-6">
            <div className="flex justify-between lg:justify-end cardBackgroundColor p-4 pb-4 mb-4 px-5 items-center">
              <div className="lg:hidden" id="hideDropDown">
                <ButtonCommonTopNew
                  className="w-28 flex items-center whitespace-nowrap px-2 gap-1 border p-2 text-sm rounded-lg cursor-pointer"
                  onClick={() => dispatch(showSharepost())}
                >
                  <HiShare
                    fontSize="small"
                    className="w-4 h-4 cursor-pointer primaryIcon"
                  />
                  Share Post
                </ButtonCommonTopNew>
              </div>
              <div className="">
                <div
                  className={`p-1 rounded-lg flex items-center ${
                    isGrid == false
                      ? "bg-blurred-gradient"
                      : "bg-blurred-gradientright"
                  } ${"cursor-pointer"}`}
                >
                  {isMobile == false ? (
                    isGrid == true ? (
                      <ButtonGridActiveNew
                        className="grid-div"
                        onClick={() => {
                          updatePreference(true);
                        }}
                      >
                        <ViewModule className={`${"gridicon-styleNew"}`} />
                      </ButtonGridActiveNew>
                    ) : (
                      <ButtonGridNew
                        className="grid-div"
                        onClick={() => updatePreference(true)}
                      >
                        <ViewModule className={`${"gridicon-styleNew"}`} />
                      </ButtonGridNew>
                    )
                  ) : (
                    ""
                  )}
                  {isGrid == false ? (
                    <ButtonGridActiveNew
                      className="grid-div"
                      onClick={() => updatePreference(false)}
                    >
                      <ViewList className={`${"listicon-styleNew"}`} />
                    </ButtonGridActiveNew>
                  ) : (
                    <ButtonGridNew
                      className="grid-div"
                      onClick={() => updatePreference(false)}
                    >
                      <ViewList className={`${"listicon-styleNew"}`} />
                    </ButtonGridNew>
                  )}
                </div>
              </div>
            </div>
            {filteredPost?.length > 0 ? (
              <div
                class={`${
                  isGrid == true
                    ? "grid-cols-2"
                    : "grid-cols-1 justify-items-center"
                } ${"grid gap-4"} px-5`}
              >
                {filteredPost &&
                  filteredPost.map((item, idx) => (
                    <ReflectionCards
                      item={item}
                      key={idx}
                      gridView={isGrid}
                      saveFilter={saveFilter}
                    />
                  ))}
              </div>
            ) : (
              <div className="grid grid-cols-1">
                <div className="justify-center justify-self-center">
                  {/* <h3>No Results Found</h3> */}
                </div>
              </div>
            )}
            <div className="grid grid-cols-1 mt-6">
              <div className="justify-center justify-self-center">
                {loading && <CommunityLoadMoreLoader />}
                {hasMore && filteredPost?.length > 0 && (
                  <ButtonCommonTopNew
                    className="px-5 border p-2 text-sm rounded-lg cursor-pointer"
                    onClick={loadMorePost}
                  >
                    Load more
                  </ButtonCommonTopNew>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Feed;
